// LOCATIONS
export const getLocationsQuery = `
  {
    locations(first: 250) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
